<template>
  <div class="role-authority">
    <div class="role-authority-container">
      <div class="left-container">
        <div
          :class="activeIndex === index ? 'active role' : 'role'"
          v-for="(item, index) in roleList"
          :key="index"
          @click="selectRoleId(item, index)"
        >
          <span class="img"></span>
          <span class="role-name">{{ item.roleName }}</span>
        </div>
      </div>
      <div class="right-container">
        <div class="top-container" v-if="roleName">
          <div class="title">{{ roleName }}</div>
          <div class="search">
            <el-input
              class="gray white w256"
              placeholder="搜索员工名"
              prefix-icon="el-icon-search"
              v-model="searchStaff"
              clearable
              @keyup.enter.native="searchPeople"
            >
            </el-input>
            <el-button
            v-show="
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleBizRoleUserManage
                ) !== -1  && keyword != 'Purchaser' && keyword != 'Acceptor'
              "
              type="text"
              class="btn-blue add"
              icon="el-icon-plus"
              @click="add"
              >添加</el-button
            >
          </div>
        </div>
        <div class="table" v-if="tableData.length > 0">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.lable"
              :width="item.width"
            />
            <el-table-column :label="label">
              <template slot-scope="scope">
                <el-tooltip
                  v-if="scope.row.controlLimit != '—'"
                  effect="dark"
                  placement="top">
                  <div slot="content">
                    <div v-for="(item,index) in scope.row.managementScope" :key="index">
                      {{ item.deptName }}
                      <br />
                    </div>
                  </div>
                  <div
                  v-if="OPERATION_LIST.findIndex(
                      (item) => item === OPERATIONS_BTNS.roleBizRoleUserManage
                    ) != -1 && keyword != 'Purchaser' && keyword != 'Acceptor'"
                  >
                    <!-- <p v-if="keyword == 'FinancialHead' && scope.row.controlLimit != '—'">{{ scope.row.controlLimit }}</p> -->
                    <p class="controlLimit" @click="setUp(scope.row)">{{ scope.row.controlLimit }}</p>
                  </div>
                  <p v-else>{{ scope.row.controlLimit }}</p>
                </el-tooltip>
                <div v-else>
                  <p  
                    v-if=" OPERATION_LIST.findIndex(
                      (item) => item === OPERATIONS_BTNS.roleBizRoleUserManage
                    ) != -1 && keyword != 'Purchaser' && keyword != 'Acceptor'"
                    class="controlLimit"
                    @click="setUp(scope.row)"
                  >{{ scope.row.controlLimit }}</p>
                  <p
                    v-show="OPERATION_LIST.findIndex(
                      (item) => item === OPERATIONS_BTNS.roleBizRoleUserManage
                    ) == -1"
                  >{{ scope.row.controlLimit }}</p>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="150"
              v-if="keyword != 'Purchaser' && keyword != 'Acceptor'"
            >
              <template slot-scope="scope">
                <el-button
                  v-if="keyword == 'cashier'"
                  type="text"
                  class="btn-text"
                  @click="setUpBill(scope.row)"
                  >设置单据</el-button
                >
                <el-button
                v-show="
                    OPERATION_LIST.findIndex(
                      (item) => item === OPERATIONS_BTNS.roleBizRoleUserManage
                    ) !== -1
                  "
                  type="text"
                  class="btn-text-red"
                  @click="remove(scope.row)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
        <div class="nothing" v-if="tableData.length == 0">
          <div class="nothing-left">
            <h1>什么是角色？</h1>
            <ul>
              <li>
                角色指团队成员的专业分工类别，可由1位或多位成员
                组成，如模块管理员、财务审核人、工薪制表人等。
              </li>
              <li>
                目前，“角色”仅运用于审批应用的流程设计。在审批管
                理后台，管理员可选择成员成为某种“角色”从而进行审
                批操作，如选择张某某成为“财务审核人”作为报销流程
                的财务审核人进行审批工作。
              </li>
              <li>
                用“角色”作为审批人，可避免因成员离职变动，审批流
                失效的情况。该“角色”中的剩余成员可继续完成该审批， 提高审批效率。
              </li>
            </ul>
          </div>
          <div class="nothing-right">
            <div>
              <img src="../../../assets/role-nothing.png" />
            </div>
            <p>报销审批流程</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 添加角色成员 -->
    <el-dialog
      title="添加角色成员"
      :visible.sync="stayDistributionDialogVisible"
      width="540px"
      :before-close="stayDistributionClose"
    >
      <div class="stayDistribution">
        <div class="table-right">
          <p class="title">每次最多可添加1个成员</p>
          <tree-people
            :companyList="companyList"
            :departmentId="departmentId"
            @selectTreeNodeList="selectDepartmentList"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="stayDistributionClose"
          >取 消</el-button
        >
        <el-button type="primary" @click="stayDistributionConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 选择部门 -->
    <all-department-dialog
      :keyword="keyword"
      :departmentDialog="departmentDialog"
      @allOPenOrCloseDepartmentDialog="allOPenOrCloseDepartmentDialog"
      @allSubmitSelectData="allSubmitSelectData"
    ></all-department-dialog>

    <!-- 编辑模块管理范围 -->
    <el-dialog
      class="module-management"
      title="编辑管理范围"
      :visible.sync="modModuleManagementScopeDialogVisible"
      width="558px"
      :before-close="modModuleManagementScopeClose"
    >
      <div class="modModuleManagementScope">
        <div class="selectModule"
          v-for="(item,index) in moduleList"
          :key="index"
        >
          <el-checkbox>{{item.name}}</el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="modModuleManagementScopeDialogVisible = false"
          >取 消</el-button
        >
        <el-button type="primary" @click="modModuleManagementScopeConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 编辑管理单据 -->
    <el-dialog
      class="module-management"
      title="管理单据"
      :visible.sync="modBillDialogVisible"
      width="558px"
      :before-close="modBillClose"
    >
      <div class="modBillManagementScope">
        <div
          class="select-bill-type"
          v-for="(item,index) in billList"
          :key="index"
        >
          <div class="bill-type">{{item.title}}</div>
          <div class="select-bill-container">
            <div
              class="select-bill"
              v-for="(v,idx) in item.list"
              :key="idx"
            >
              <el-checkbox-group v-model="selectBillList">
                <el-tooltip class="item" effect="dark" :content="v.name" placement="top" :disabled="v.isDisable">
                  <el-checkbox :label="v.id">
                    {{v.name}}
                  </el-checkbox>
                </el-tooltip>
              </el-checkbox-group>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer bill-footer">
        <div>已选单据：（{{selectBillList.length}}种）</div>
        <div>
          <el-button @click="modBillClose"
            >取 消</el-button
          >
          <el-button type="primary" @click="modBillCloseConfirm"
            >确 定</el-button
          >
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import TreePeople from "@/components/tree-people.vue";
import PaginationTpl from "@/components/PaginationTpl.vue";
import Role from "@/models/role.js";
import AllDepartmentDialog from "@/components/all-department-dialog.vue";
import { mapChild, strLen } from "@/common/js/utils.js";
import { getTeamId } from "common/js/storage";
import Staff from "@/models/staff.js";
import BillAdmin from "@/models/bill-admin.js";
import { operationMixins } from '@/common/mixins/operation/operation.js'
export default {
  mixins: [operationMixins],
  components: {
    TreePeople,
    PaginationTpl,
    AllDepartmentDialog
  },

  data() {
    return {
      roleList: [],
      tableData: [],
      totalNum: 0,
      currentPage: 1,
      tableTitleList: [
        { prop: "name", lable: "姓名", width: "" },
        { prop: "phone", lable: "手机号", width: "" },
        { prop: "department", lable: "所属部门", width: "" },
      ],
      roleName: "",
      searchStaff: "",
      activeIndex: "",
      stayDistributionDialogVisible: false,
      /* 变更部门数据 */
      companyList: [],
      departmentId: 0,
      /* 选择的模块类型 */
      selectType: null,
      selectRole: null,
      userId: null,
      // 角色唯一标识
      keyword: null,
      label: '管理范围',
      
      /* 
        以下是选择部门字段
       */
      departmentDialog: false,

      /* 是否开启模块管理范围 */
      modModuleManagementScopeDialogVisible: false,
      moduleList: [],
      /* 是否开启管理单据 */
      modBillDialogVisible: false,
      billList: [],
      selectBillList: [],
      controlLimit: []
    };
  },

  created() {
    config()
    this.initTwoLevelRoleList();
    this.initDepartmentList();
    this.initModulList()
    this.initBill()
  },
  mounted() {
    this.$nextTick(() => {
      this.$bus.emit("isShowTopMenu", false);
    });
  },

  methods: {
    /* 二级权限列表 */
    initTwoLevelRoleAuthorityList() {
      let type = this.selectType;
      let roleId = this.selectRole;
      let name = this.searchStaff;
      let currentPage = this.currentPage;
      Role.getTwoLevelRoleAuthorityList(type, roleId, name, currentPage).then(
        (res) => {
          if (res.success) {
            this.totalNum = res.result.totalNum;
            let arr = [];
            res.result.items.map((i) => {
              let obj = {};
              obj.userId = i.userId;
              obj.name = i.name ? i.name : "—";
              obj.phone = i.phoneNo ? i.phoneNo : "—";
              obj.department = i.deptName ? i.deptName : "—";
              obj.managementScope = i.bizRoleUserAuthorityList;
              let controlLimit = [];
              let selectBillList = [];
              if (i.bizRoleUserAuthorityList) {
                i.bizRoleUserAuthorityList.map((v) => {
                  if (this.keyword == 'Purchaser' || this.keyword == 'Acceptor') {
                    controlLimit.push(v.canteenName);
                  } else {
                    controlLimit.push(v.deptName);
                  }
                  if (v.reimbursementFormIds) {
                    let billArr = v.reimbursementFormIds.split(',')
                    billArr.map(i => {
                      selectBillList.push(Number(i))
                    })
                  }
                });
              }
              obj.selectBillList = [...new Set(selectBillList)]
              if (controlLimit.length > 0) {
                obj.controlLimit = controlLimit.join(";");
              } else {
                obj.controlLimit = "—";
              }
              arr.push(obj);
            });
            this.tableData = arr;
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        }
      );
    },

    /* 二级角色列表 */
    initTwoLevelRoleList() {
      Role.getTwoLevelRoleList().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((i) => {
            let obj = {};
            obj.roleId = i.roleId;
            obj.roleName = i.name;
            obj.type = i.type;
            obj.keyword = i.keyword;
            if (i.type == 2) {
              arr.push(obj);
            }
          });
          this.roleList = arr;
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    /* 获取部门数据 */
    initDepartmentList() {
      let searchDepartment = "";
      let id = getTeamId()
      Staff.getDepartmentPeopleList(id, searchDepartment).then((res) => {
        if (res.success) {
          this.companyList = mapChild(res.result);
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    searchPeople() {
      this.currentPage = 1;
      this.initTwoLevelRoleAuthorityList();
    },

    /* 翻页 */
    onQueryChange(data) {
      this.currentPage = data.currentPage;
      this.initTwoLevelRoleAuthorityList();
    },

    /* 选择角色 */
    selectRoleId(row, index) {
      this.activeIndex = index;
      this.roleName = row.roleName;
      this.selectType = row.type;
      this.selectRole = row.roleId;
      this.keyword = row.keyword;
      this.label = '管理范围'
      if (row.keyword == 'Purchaser' || row.keyword == 'Acceptor') {
        this.label = '食堂范围'
      }
      this.initTwoLevelRoleAuthorityList();
    },

    /* 二级管理员删除角色 */
    _postDelTwoLevelRoleAuthority(data) {
      Role.postDelTwoLevelRoleAuthority(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.initTwoLevelRoleAuthorityList();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    remove(row) {
      this.$confirm("角色成员删除后不可恢复，是否继续？", "确认删除成员", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: "btn-red",
        cancelButtonClass: "btn-gray",
      }).then(() => {
        let userId = row.userId;
        let roleId = this.selectRole;
        let type = this.selectType;
        let data = {
          userId,
          roleId,
          type,
        };
        this._postDelTwoLevelRoleAuthority(data);
      });
    },

    /* 
      以下是添加角色成员方法 
    */
    /* 添加 */
    add() {
      if (this.roleName) {
        this.userId = '';
        this.departmentId = 0,
        this.stayDistributionDialogVisible = true;
      } else {
        this.$message({
          type: "error",
          message: "请先选择角色",
        });
      }
    },

    /* 二级管理员添加角色 */
    _postAddTwoLevelRoleAuthority(data) {
      Role.postAddTwoLevelRoleAuthority(data).then((res) => {
        if (res.success) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.initTwoLevelRoleAuthorityList();
          this.stayDistributionClose();
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      });
    },

    stayDistributionClose() {
      this.stayDistributionDialogVisible = false;
      this.$bus.emit('clearSelect', 0)
    },

    stayDistributionConfirm() {
      if (!this.userId) {
        this.$message({
          type: "error",
          message: "请先选择成员",
        });
        return
      }
      let userId = this.userId;
      let roleId = this.selectRole;
      let type = this.selectType;
      let data = {
        userId,
        roleId,
        type,
      };
      this._postAddTwoLevelRoleAuthority(data);
    },

    selectDepartmentList(v) {
      this.userId = v.id2;
    },
  
    /*
      以下是选择部门方法
    */
    setUp(row) {
      if (this.selectType == 1) {
        this.modModuleManagementScopeDialogVisible = true
      } else {
        this.userId = row.userId
        this.departmentDialog = true;
        let arr = []
        row.managementScope.map(i => {
          let obj = {}
          obj.id = i.managerDepartmentId
          obj.name = i.deptName
          arr.push(obj)
        })
        this.$bus.emit('initSelectAllDepartmentList', arr)
      }
    },

    /* 关闭部门弹窗 */
    allOPenOrCloseDepartmentDialog(data) {
      this.departmentDialog = data;
    },

    /* 确定部门弹窗 */
    allSubmitSelectData(v) {
      let bizRoleUserAuthorityList = []
      v.map(i => {
        let obj = {}
        obj.managerDepartmentId = i.id
        obj.managerDepartmentLevel = i.level
        bizRoleUserAuthorityList.push(obj)
      })
      let userId = this.userId
      let roleId = this.selectRole
      let type = this.selectType
      let data = {
        userId,
        roleId,
        type,
        bizRoleUserAuthorityList
      }
      if (type != 1) {
        if (bizRoleUserAuthorityList.length == 0) {
          this.$message.error('请选择部门')
          return
        }
        Role.postControl(data).then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.initTwoLevelRoleAuthorityList();
            this.allOPenOrCloseDepartmentDialog(false);
          } else {
            this.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      }
    },

    /* 
      以下是编辑模块管理范围
    */
    initModulList() {
      let res = [
        {id:1, name: '工薪模块'},
        {id:2, name: '报销模块'},
        {id:3, name: '风险评估模块'},
        {id:4, name: '权威发布模块'},
        {id:5, name: '固定资产模块'},
        {id:6, name: '伙食模块'},
      ]
      // Role.postAddTwoLevelRoleAuthority(data).then((res) => {
      //   if (res.success) {
        let arr = []
        res.map(i => {
          let obj = {}
          obj.id = i.id
          obj.name = i.name
          arr.push(obj)
        })
        this.moduleList = arr

      //   } else {
      //     this.$message({
      //       type: "error",
      //       message: res.message,
      //     });
      //   }
      // });
    },
    modModuleManagementScopeClose() {
      this.modModuleManagementScopeDialogVisible = false
    },
    modModuleManagementScopeConfirm() {
      // Role.postAddTwoLevelRoleAuthority(data).then((res) => {
      //   if (res.success) {
      //     this.$message({
      //       type: "success",
      //       message: "编辑成功",
      //     });
      //     this.initTwoLevelRoleAuthorityList();
      //   } else {
      //     this.$message({
      //       type: "error",
      //       message: res.message,
      //     });
      //   }
      // });
    },

    /* 以下是编辑管理范围 */
    setUpBill(row) {
      this.userId = row.userId
      this.selectBillList = row.selectBillList
      this.controlLimit = row.controlLimit
      this.modBillDialogVisible = true
    },
    /* 获取单据类型数据 */
    initBill() {
      let queryStr = ''
      BillAdmin.getReimbursementTypeList(queryStr).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.title = i.name
            obj.list = []
            i.reimburseFormList.map(v => {
              let obj2 = {}
              obj2.id = v.id
              obj2.name = v.name
              obj2.isDisable = strLen(v.name)>14?false:true
              obj.list.push(obj2)
            })
            arr.push(obj)
          })
          this.billList = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },
    modBillClose() {
      this.modBillDialogVisible = false
    },
    modBillCloseConfirm() {
      if (this.controlLimit == "—") {
        this.$message.error('请先设置管理范围')
        return 
      }
      let userId = this.userId
      let roleId = this.selectRole;
      let reimbursementFormIds = this.selectBillList.join(',')
      let data = {
        userId,
        roleId,
        reimbursementFormIds
      }
      Role.postSetBill(data).then(res => {
        if (res.success) {
          this.selectBillList = []
          this.initTwoLevelRoleAuthorityList()
          this.modBillClose()
        } else {
          this.$message({
            type: "error",
            message: res.message,
          });
        }
      })
    }
  },
};
</script>

<style lang='scss' scoped>
.role-authority {
  flex: 1;
  background: $bg-white;
  .role-authority-container {
    height: 100%;
    display: flex;
  }
  .left-container {
    width: 288px;
    padding: 16px;
    box-sizing: border-box;
    border-right: 1px solid $bg-ShallowLightSnow;
    .role {
      height: 40px;
      padding: 0px 16px;
      font-size: $fs-small-l;
      @include flex-start;
      cursor: pointer;
      .img {
        width: 16px;
        height: 16px;
        margin-right: 20px;
        background: url("../../../assets/role.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
      .role-name {
        height: 40px;
        line-height: 40px;
        @include two-wrap-ellipsis(1);
      }
      &:hover {
        background: $bg-ChangeDepartmentHighTree;
        color: $color-ReddishBlue;
        .img {
          background: url("../../../assets/role-high.png");
          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
    .active {
      background: $bg-ChangeDepartmentHighTree;
      color: $color-ReddishBlue;
      .img {
        background: url("../../../assets/role-high.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }
  }
  .right-container {
    flex: 1;
    padding: 16px 20px;
    position: relative;
    .top-container {
      @include flex-between;
      margin-bottom: 20px;
      .title {
        padding-left: 10px;
        font-size: $fs-medium-s;
        color: $color-BlackGrey;
        border-left: 4px solid $color-DeepReddishBlue;
      }
      .search {
        display: flex;
        .add {
          margin-left: 12px;
          padding: 0;
        }
        .el-input__prefix, .el-input__suffix {
          top: 3px;
        }
      }
    }
    .controlLimit {
      color: $color-DeepReddishBlue;
      cursor: pointer;
    }
    .nothing {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      @include flex-center;
      .nothing-left {
        width: 350px;
        margin-right: 30px;
        h1 {
          text-align: left;
        }
        ul {
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-grey;
          text-align: left;
          li {
            margin-bottom: 21px;
            line-height: 20px;
            list-style-type: disc;
          }
        }
      }
      img {
        width: 270px;
        height: 390px;
      }
      p {
        font-size: $fs-small-l;
        font-weight: 400;
        color: $color-LightGrey;
        margin-top: 24px;
      }
    }
  }

  .stayDistribution {
    height: 300px;
    overflow-y: auto;
    margin: 16px;
    background: $bg-ChangeDepartmentTree;
    .el-input__prefix,
    .el-input__suffix {
      top: 2px;
    }
    .table-right {
      background: $bg-ChangeDepartmentTree;
      box-sizing: border-box;
      overflow: hidden;
      .title {
        height: 36px;
        font-weight: 400;
        line-height: 36px;
        border-radius: 2px;
        margin-bottom: 14px;
        text-align: left;
        padding-left: 28px;
        font-size: $fs-small-l;
        color: $color-OriginYellow;
        background: $bg-OriginYellow;
      }
    }
  }

  .modModuleManagementScope {
    @include flex-between;
    flex-wrap: wrap;
    width: 494px;
    padding: 21px;
    box-sizing: border-box;
    border: 1px solid $bg-DoopLightSnow;
    .selectModule {
      @include flex-start;
      padding-left: 13px;
      width: 44%;
      height: 36px;
      background: #F8F9FA;
      border-radius: 2px;
      font-size: $fs-small-l;
      font-weight: 400;
      color: $color-grey;
      margin-bottom: 12px;
    }
  }
  .modBillManagementScope {
    @include flex-column-start;
    width: 494px;
    height: 360px;
    padding: 21px;
    box-sizing: border-box;
    border: 1px solid $bg-DoopLightSnow;
    overflow-y: auto;
    .select-bill-type {
      width: 100%;
      .bill-type {
        text-align: left;
        padding-left: 6px;
        margin-bottom: 10px;
        border-left: 3px solid $bg-DeepReddishBlue;
      }
      .select-bill-container {
        width: 100%;
        @include flex-start;
        flex-wrap: wrap;
        .select-bill {
          width: 31%;
          height: 36px;
          line-height: 36px;
          text-align: left;
          box-sizing: border-box;
          background: #F8F9FA;
          border-radius: 2px;
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-grey;
          padding-left: 12px;
          margin-bottom: 12px;
          margin-right: 15px;
        }
        .select-bill:nth-child(3n) {
          margin-right: 0px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.role-authority {
  .stayDistribution {
    .tree-people {
      padding: 0px 20px;
      .el-tree {
        background: $bg-ChangeDepartmentTree;
      }
      .search {
        .el-input__inner {
          background: $bg-ChangeDepartmentTree;
        }
      }
    }
  }
  .module-management {
    .el-dialog__header {
      border-bottom: none;
      padding-left: 29px;
      .el-dialog__headerbtn {
        right: 29px;
      }
    }
    .el-dialog__body {
      padding: 20px 32px;
    }
    .el-dialog__footer {
      border-top: none;
      justify-content: flex-end;
      padding-right: 29px;
    }
  }
  .select-bill {
    .el-checkbox {
      @include flex-start;
      height: 36px;
      .el-checkbox__label {
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical
      }
    }
  }
  .bill-footer {
    width: 100%;
    font-size: $fs-small-l;
    font-weight: 400;
    color: $color-grey;
    padding-left: 30px;
    @include flex-between;
  }
  .search {
    .el-input__prefix, .el-input__suffix {
      top: 3px;
    }
  }
}
</style>
